module.exports = __webpack_public_path__ + "static/media/restoran-gril-4.c6307bb6.jpg";